"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const DialogConstants_1 = require("./DialogConstants");
var DialogType;
(function (DialogType) {
    DialogType[DialogType["Hidden"] = 0] = "Hidden";
    DialogType[DialogType["Alert"] = 1] = "Alert";
    DialogType[DialogType["Confirm"] = 2] = "Confirm";
    DialogType[DialogType["Custom"] = 3] = "Custom";
    DialogType[DialogType["Input"] = 4] = "Input";
    DialogType[DialogType["Select"] = 5] = "Select";
    DialogType[DialogType["BlockedNumbers"] = 6] = "BlockedNumbers";
    DialogType[DialogType["BlackWord"] = 7] = "BlackWord";
})(DialogType = exports.DialogType || (exports.DialogType = {}));
const initialState = {
    type: DialogType.Hidden
};
function dialogReducer(state = null, action) {
    switch (action.type) {
        case DialogConstants_1.default.ShowAlert:
            {
                return Object.assign({}, state, {
                    type: DialogType.Alert,
                    payload: action.payload
                });
            }
        case DialogConstants_1.default.ShowConfirm:
            {
                return Object.assign({}, state, {
                    type: DialogType.Confirm,
                    payload: action.payload
                });
            }
        case DialogConstants_1.default.ShowInput:
            {
                return Object.assign({}, state, {
                    type: DialogType.Input,
                    payload: action.payload
                });
            }
        case DialogConstants_1.default.ShowCustomDialog:
            {
                return Object.assign({}, state, {
                    type: DialogType.Custom,
                    payload: action.payload
                });
            }
        case DialogConstants_1.default.ShowSelect:
            {
                return Object.assign({}, state, {
                    type: DialogType.Select,
                    payload: action.payload
                });
            }
        case DialogConstants_1.default.Close:
            {
                return Object.assign({}, state, {
                    type: DialogType.Hidden,
                    payload: null
                });
            }
        case DialogConstants_1.default.ShowBlockedNumbersDialog:
            {
                return Object.assign({}, state, {
                    type: DialogType.BlockedNumbers,
                    payload: action.payload
                });
            }
        case DialogConstants_1.default.ShowBlackWordDialog:
            {
                return Object.assign({}, state, {
                    type: DialogType.BlackWord,
                    payload: action.payload
                });
            }
        default:
            return state;
    }
}
exports.default = dialogReducer;


//////////////////
// WEBPACK FOOTER
// ./client/src/shared/Dialog/DialogReducer.ts
// module id = 475
// module chunks = 0 1 2